module.exports = __webpack_public_path__ + "img/65.86841491.jpg";